export enum CookieName {
  CURRENT_HUB_ID = "currentHubId",
  REDIRECT_LOGIN = "redirectLogin",
  LOGIN_INTENT = "loginIntent",
  RTMDX_SORT_BY = "rtmdx-sort-by",
  RTMDX_SORT_ORDER = "rtmdx-sort-order",
  DISMISS_BOUNDARY_CTA = "dismiss-boundary-cta",
  COLOR_SCHEME = "color-scheme",
  NAV_ACTIVE_TAB = "nav-active-tab",
  NAV_COLLAPSED_SECTIONS = "nav-collapsed",
  DISMISS_LEARNING_CENTER_CTA = "dismiss-learning-center-cta",
}

export type NavTab = "tracking" | "training" | "comms" | "cardiff";

/**
 * Get active nav tab from cookies (SSR-compatible)
 */
export const getNavActiveTabFromCookies = (cookies?: string | null): NavTab => {
  if (!cookies) return "tracking";
  const match = cookies.match(/nav-active-tab=([^;]+)/);
  const value = match ? match[1] : null;
  if (
    value === "tracking" ||
    value === "training" ||
    value === "comms" ||
    value === "cardiff"
  ) {
    return value;
  }
  return "tracking";
};

/**
 * Get collapsed nav sections from cookies (SSR-compatible)
 */
export const getNavCollapsedSectionsFromCookies = (
  cookies?: string | null,
): string[] => {
  if (!cookies) return [];
  const match = cookies.match(/nav-collapsed=([^;]+)/);
  if (!match) return [];
  try {
    const decoded = decodeURIComponent(match[1]);
    const parsed = JSON.parse(decoded);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/**
 * Set collapsed nav sections cookie (client-side only)
 */
export const setNavCollapsedSectionsCookie = (sections: string[]) => {
  const encoded = encodeURIComponent(JSON.stringify(sections));
  document.cookie = `${CookieName.NAV_COLLAPSED_SECTIONS}=${encoded}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
};

export const getCookie = (request: Request, cookieName: CookieName) => {
  const value = `; ${request.headers.get("Cookie")}`;
  const parts = value.split(`; ${cookieName}=`);

  if (!parts) {
    return null;
  }

  const cookieValue = parts.pop()?.split(";")?.shift();

  return cookieValue;
};

export const setCookie = (cookieName: CookieName, value: string | object) => {
  document.cookie = `${cookieName}=${value}; path=/;`;
};
